<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Documents Executed under Common Seal</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/commonSeal"> -->
          <button  (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/commonSeal/edit?goveva=true&email=', 'method':'put', 'menu': 'commonSeal'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
  
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse"[ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <!-- <form (document:click)="cesDate.close()"> -->
            <div class="row">
              <div class="col-md-4">
                <label>Date of the resolution authorising the use of common seal</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfResolution" class="form-control" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" name="dateOfResolution" ngbDatepicker #b="ngbDatepicker"
                    [(ngModel)]="dateOfResolution" (click)="b.toggle();">
                  <button class="input-group-addon" (click)="b.toggle();" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
                <br>
              </div>
  
              <!-- <div class="col-lg-4">
                <label>Date of affixing seal on the document</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfAffixing" [(ngModel)]="dateOfAffixing" [minDate]="futureToDate" class="form-control"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAffixing" ngbDatepicker
                    #cesDate="ngbDatepicker" (click)="cesDate.toggle()" [ngModelOptions]="{standalone: true}">
                  <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
  
  
              <div class="col-md-3">
                <!-- <label>Date of affixing seal on the document</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfAffixing" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAffixing" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfAffixing">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                   To:&nbsp;
                  <input id="dateOfAffixingTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAffixingTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfAffixingTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </section>
  
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="masterdocumentcommonSealTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Description of Documents</th>
                    <th>Date of the resolution authorising <br>the use of common seal</th>
                    <th style="display: none">Date of the resolution authorising the use of common seal</th>
                    <th>Date of affixing seal on <br>the document</th>
                    <th style="display: none">Date of affixing seal on the document</th>
                    <!-- <th>status</th> -->
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                    <td tabindex="1">
                      {{director.descriptionOfDocumemts}}
                    </td>
                    <td tabindex="1">
                      <span
                        style="display: none">{{director.dateOfResolutionauthorisingtheuseofcommonseal | date :"yMMdd"}}</span>
                      {{director.dateOfResolutionauthorisingtheuseofcommonseal | date : "dd-MM-y"}}
                    </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfResolutionauthorisingtheuseofcommonseal | date : "dd-MM-y"}}
                    </td>
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfaffixixngsealonthedocument | date : "yMMdd"}}</span>
                      {{director.dateOfaffixixngsealonthedocument | date : "dd-MM-y"}}
                    </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfaffixixngsealonthedocument | date : "dd-MM-y"}}
                    </td>
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" [appHasPermission]="{'Url': '/register/commonSeal/edit?goveva=true&email=', 'method':'put', 'menu': 'commonSeal'}" (click)="editcommonSeal(director._id)" class="btn-sm btn btn-warning">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" [appHasPermission]="{'Url': '/register/commonSeal/edit?goveva=true&email=', 'method':'put', 'menu': 'commonSeal'}" class="btn-sm btn btn-danger" delete-meeting="5cee33d225242e023acfb2d4"
                          (click)="confirmDelete(director._id)">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete document executed under common seal details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletecommonSealdetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>